export const sortList = (list, subj) => {
    //Controllo se e' presente "DESC"
    var isDesc = false;
    var indexDesc = subj.indexOf("DESC");

    if( indexDesc > -1 ){
        isDesc = true;
        subj = subj.substring(0, indexDesc);
    }

    var subjArray = subj.split(".");

    var cmp = (first, second) => {
        //recupero i campi        
        for( var el = 0; el< subjArray.length; el++){
            if(first != null )
                first  = first[ subjArray[ el ] ];
            if(second != null )
            second = second[ subjArray[ el ] ];
        }
        //var a = typeof first === 'string' ? first.toLowerCase() : first == null ? "" : first;
        //var b = typeof second === "string" ? second.toLowerCase() : second == null ? "" : second;
        var a = typeof first  === 'string' ? first.toLowerCase()  : first  ;
        var b = typeof second === "string" ? second.toLowerCase() : second ;
        if(isDesc)
            return (a < b ? 1 : a > b ? -1 : 0);
        else
            return (a < b ? -1 : a > b ? 1 : 0);
    }
    var l = list.sort(cmp);
    return l;
}


// WEBPACK FOOTER //
// ./src/Utils/Sorting.js